import type { StaticImageData } from 'next/image';
import { requiredAssetsToAssetMap } from '@/lib/utils/assetMap';

type LogoMap = Record<string, { src: StaticImageData | string; width: number; height: number }>;

// @ts-expect-error require.context is not defined in types
const logos = (): LogoMap => requiredAssetsToAssetMap(require.context('@/static/logo/supplier/66x22', false, /\.png$/));

export default logos;
